module.exports = function (arr, index, elements) {
  arr.splice.apply(arr, [index, 1].concat(elements));
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx-transpiler/src/helpers/injectAt.js
 ** module id = 423
 ** module chunks = 0
 **/